import { css } from '@adornis/chemistry/directives/css.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { badgeStyle } from '@ils/theme/badges.js';
import { html, nothing } from 'lit';

export const filterBadge = stateful(
  ({ selected, title, onClick }: { selected: boolean; title: string; onClick: () => void }) => {
    const design = useObservable(() => DesignSystem.currentTheme, []);
    if (!design) return nothing;
    return html`
      <x-text
        ${css({
          ...badgeStyle(),
          cursor: 'pointer',
          color: selected ? design.colors.on.neutral.string : design.colors.neutral.string,
          backgroundColor: selected ? design.colors.neutral.string : 'transparent',
          border: selected ? '1px solid transparent' : `1px solid ${design.colors.neutral.string}`,
        })}
        @click=${() => onClick()}
      >
        ${title}
      </x-text>
    `;
  },
);
